<template>
  <div class="navigation-item">
    <a
      class="navigation-item__link"
      :is="isOpenable ? 'div'
        : href ? 'a'
        : to ? 'router-link'
        : 'div'"
      :href="href"
      :to="to"
      @click="click"
    >
      <Icon
        v-if="icon"
        class="navigation-item__icon"
        :name="icon"
      />
      <div
        class="navigation-item__text"
        v-html="text"
      />
      <Icon
        v-if="isOpenable"
        class="navigation-item__caret"
        :name="isOpened ? 'up' : 'down'"
      />
    </a>
    <div
      v-if="isOpenable"
      v-show="isOpened"
      class="navigation-item__subitems"
    >
      <a
        v-for="item in items"
        :key="item.text"
        class="navigation-item__subitem"
        :is="href ? 'a' : to ? 'router-link' : 'div'"
        :href="href"
        :to="to"
        v-html="item.text"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'NavigationItem',
  designVersion: '2.0.0',
  designLink: 'https://www.figma.com/file/MAH9taJUL2HzqvGofNpg5Z/Components?node-id=1256%3A67',
  props: {
    text: String,
    icon: String,
    href: String,
    to: [Object, String],
    items: Array
  },
  data () {
    return {
      isOpened: false
    }
  },
  computed: {
    isOpenable () {
      return this.items && this.items.length
    }
  },
  methods: {
    click (e) {
      if (this.isOpenable) {
        this.isOpened = !this.isOpened
      }
      this.$emit('click', e)
    }
  }
}
</script>

<style lang="scss" scoped>
.navigation-item {
  display: block;
  color: $color-black;
  user-select: none;

  &__link {
    @include text-md;
    display: flex;
    align-items: center;
    padding: 12px 16px;
    text-decoration: none;
    outline: none;
    color: inherit;
    font-weight: $font-weight-semibold;
    position: relative;
    z-index: 1;
    cursor: pointer;
    transition: $transition-default;

    .no-touch &:hover {
      background-color: map_get($color-neutral-black, 4);
    }
  }

  &__icon {
    flex: 0 0 auto;
    max-width: 100%;
    width: 18px;
    height: 18px;
    margin-right: 16px;
  }

  &__text {
    flex: 0 1 auto;
    max-width: 100%;
    min-width: 0;
  }

  &__caret {
    flex: 0 0 auto;
    width: 16px;
    height: 16px;
    margin-left: 8px;
  }

  &__subitems {
    padding-bottom: 6px;
    margin-top: -6px;
  }

  &__subitem {
    display: block;
    @include text-sm;
    padding: 6px 0 6px 62px;
    text-decoration: none;
    outline: none;
    color: inherit;
    font-weight: $font-weight-semibold;
    transition: $transition-default;

    .no-touch &:hover {
      background-color: map_get($color-neutral-black, 4);
    }
  }
}
</style>
